module.exports = __webpack_public_path__ + "img/gh.c63547f9.jpg";